import httpServices from "@/components/service";

export default {
    async get(campaignId) {
        console.assert(typeof campaignId == "number");
        return !campaignId ? { name: null, shortName: null, id: 0 } : await httpServices.get("/campaigns/" + campaignId);
    }
};



// WEBPACK FOOTER //
// ./src/services/currentCampaign.js